import { render } from "./PuntoCyanStreamlined.vue?vue&type=template&id=078545e5&scoped=true"
import script from "./PuntoCyanStreamlined.vue?vue&type=script&lang=ts"
export * from "./PuntoCyanStreamlined.vue?vue&type=script&lang=ts"

import "./PuntoCyanStreamlined.vue?vue&type=style&index=0&id=078545e5&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-078545e5"

export default script